export default class Custom {
  constructor() {
    // this._separateTitles();
  }
  _separateTitles() {
    const className = 'title-separated';
    const selector = `h2:not(.entry-title):not(.${className}), .h2:not(.entry-title):not(.${className})`;
    const nodes = document.querySelectorAll(selector);
    nodes.forEach(tag => tag.classList.add(className));
  }
  finalize() {}
}



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/Custom.js